/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { ReducerType } from '../_store';
import { Category } from '../_store/slice/book-categories';
import server from '../_api/backend';
import * as toast from '../_store/slice/toast';

export function AsideBook(props: any) {
  const bookCategories = useSelector<ReducerType, Category>((state) => state.bookCategories);
  const [mobileSubCategories, setMobileSubCategories] = useState<any>([]);
  const [mobileMainCategories, setMobileMainCategories] = useState<any>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getCategories();
  }, [props]);

  const getCategories = async () => {
    await server
      .getCategories()
      .then((payload) => {
        setMobileMainCategories(payload);
        for (let i = 0; i < payload.length; i++) {
          if (payload[i].id === String(props.mainId)) {
            setMobileSubCategories(payload[i]);
          }
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  return (
    <aside>
      <h3>도서목록</h3>
      {window.innerWidth >= 769
        ? bookCategories.categories.map((category: any, i: any) => (
            <div key={category.id}>
              <h4>{category.name}</h4>
              {bookCategories.subCategories[i].map((book: any) => (
                <NavLink
                  activeClassName="active"
                  to={`/book-categories/${book.id}/books`}
                  key={book.id}
                >
                  {book.name}
                </NavLink>
              ))}
            </div>
          ))
        : bookCategories.categories.map((category: any) => (
            <div key={category.id}>
              <h4>{category.name}</h4>
              {Number(category.id) === props.mainId &&
                mobileSubCategories.children?.map((book: any) => (
                  <NavLink
                    activeClassName="active"
                    to={`/book-categories/${book.id}/books`}
                    key={book.id}
                  >
                    {book.name}
                  </NavLink>
                ))}
            </div>
          ))}
    </aside>
  );
}
